export default class KdiagramCalculationResultFdmData {
  constructor(
    logSpeed,
    mePower,
    meRpm,
    minDate,
    maxDate,
    fdmLength,
    fdmDataCLength,
    consumption
  ) {
    this.logSpeed = logSpeed;
    this.mePower = mePower;
    this.meRpm = meRpm;
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.fdmLength = fdmLength;
    this.fdmDataCLength = fdmDataCLength;
    this.Consumption = consumption;
  }

}
